export enum ContinueWatchingStatus {
  WATCHING = 1,
  FINISHED = 2,
}

export type UpdateContinueWatchingItemParams = {
  mediaIri: string;
  currentTime: number;
  mediaDuration: number;
  seriesIri?: string;
  mediaType: string /*TODO: add enum*/;
};

export enum MediaTypes {
  AUDIOS = 'audios',
  LIVESTREAMS = 'live_streams',
  VIDEOS = 'videos',
}

export type User = {
  address: {
    className: string;
    country: string;
    street_address: string;
    locality: string;
    postal_code: string;
    id?: string;
  };

  groups: {
    groupId: string;
    path: string;
    roles: string[];
  }[];

  birthdate: string;
  customFields: { additional_title: string };
  email: string;
  email_verified: boolean;
  family_name: string;
  gender: string;
  given_name: string;
  last_accessed_at: number;
  last_used_identity_id: string;
  locale: string;
  name: string;
  nickname: string;
  preferred_username: string;
  provider: string;
  sub: string;
  updated_at: number;
  extra: UserExtra;
};

export type WalletItem = {
  productName: string;
  tariffType: string;
  tariffName: string;
  validFrom: string;
  validTo: string;
};

export type WalletMedium = {
  items: WalletItem[];
};

export type Wallet = {
  serialNumber: string;
  mediums: WalletMedium[];
};

// Wallets includes only valid wallets (within validity period) containing a Veejoy voucher
export type UserExtra = {
  wallets?: Wallet[];
};

export type UserProfile = {
  '@id': string;
  '@type': string;
  avatarAssetId: number;
  createdAt: string;
  id: number;
  name: string;
  updatedAt: string;
};
